"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheStrategyWrapper = void 0;
const memory_cache_1 = __importDefault(require("memory-cache"));
var hash = require('object-hash');
class CacheStrategyWrapper {
    constructor() {
        this.cacheTimeout = {
            authorized: 1000 * 60,
            notAuthorized: 1000 * 10
        };
        this.memCache = new memory_cache_1.default.Cache();
        this.keyMaker = (strategy) => {
            return hash(strategy);
        };
        this.exist = (strategy) => {
            return this.getStrategyCache(strategy) !== null;
        };
        this.getStrategyCache = (strategy) => {
            const key = this.keyMaker(strategy);
            return this.memCache.get(key);
        };
        this.addStrategyCache = (strategy, value, timeout) => {
            const key = this.keyMaker(strategy);
            this.memCache.put(key, value, timeout);
        };
        this.deleteStraetgyCache = (strategy) => {
            if (this.exist(strategy)) {
                const key = this.keyMaker(strategy);
                this.memCache.del(key);
            }
        };
        this.execute = (strategy, func) => {
            try {
                if (!this.exist(strategy)) {
                    const executingStrat = func();
                    this.addStrategyCache(strategy, executingStrat, this.cacheTimeout.authorized);
                    executingStrat
                        .then((d) => {
                        if (d.isAuthorized === false) {
                            this.addStrategyCache(strategy, executingStrat, this.cacheTimeout.notAuthorized);
                        }
                        return d;
                    }).catch(e => {
                        this.deleteStraetgyCache(strategy);
                        return e;
                    });
                }
            }
            catch (e) {
                this.deleteStraetgyCache(strategy);
            }
            return this.getStrategyCache(strategy);
        };
    }
}
exports.CacheStrategyWrapper = CacheStrategyWrapper;
//# sourceMappingURL=cacheStrategyWrapper.js.map